// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/lib/angular-rich-text-diff/angular-rich-text-diff.css
// module id = 337
// module chunks = 0